import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import * as moment from 'moment';
import { NbDialogService } from '@nebular/theme';
import { AddLogbookComponent } from '../../../add-logbook/add-logbook.component';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { StationService } from '../../../services/stations.service';
import { LogbookService } from '../../../services/logbook.service';

@Component({
  selector: 'ngx-logbooks-section',
  templateUrl: './logbooks-section.component.html',
  styleUrls: ['./logbooks-section.component.scss'],
})
export class LogbooksSectionComponent implements OnInit {
  eventsSubject: Subject<any> = new Subject<any>();
  stationId: string;
  type: number = 2;
  startDate: string = moment().startOf('month').format('YYYY-MM-DD');
  endDate: string = moment().endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  showAddLogbook: boolean = false;
  showEditLogbook: boolean = false;
  // tslint:disable-next-line: max-line-length
  range: Range = { fromDate: new Date(), toDate: new Date() };
  options: NgxDrpOptions;
  url = environment.baseEndpoint;
  presets: Array<PresetItem> = [];
  selected: { startDate: moment.Moment, endDate: moment.Moment };
  ranges: any = {
    'Hoy': [moment(), moment()],
    'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
    'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Últmo año': [moment().subtract(1, 'year').startOf('year'), moment().endOf('year')],
  };
  locale: any = {
    format: 'DD MMMM YYYY',
    separator: ' a ',
    cancelLabel: 'Cancelar',
    applyLabel: 'Aplicar',
    customRangeLabel: 'Rango personalizado',
  };
  logbookTypes = [
    'Mantenimiento',
    'Accidentes e incidentes',
    'Recepción y descarga',
    'Desviaciones',
    'Revisión de baterías',
    'Apertura de puertas',
    'Extintores',
  ];
  logbook: any = [];
  logbookType: number;

  constructor(
    private dialog: NbDialogService,
    private route: ActivatedRoute,
    private stationService: StationService,
    private logbookService: LogbookService
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });

    this.logbookService.changeLogbookEvent.subscribe(() => {
      this.showAddLogbook = false
    });

    this.logbookService.changeEditLogbookEvent.subscribe(() => {
      this.showEditLogbook = true
    });

    this.logbookService.closeEditLogbookEvent.subscribe(() => {
      this.showEditLogbook = false
    });

    this.logbookService.editLogbookEvent.subscribe((data) => {
      this.logbook = data.logbook;
      this.logbookType = data.logbook.type;
      this.stationId = data.stationId;
    })
  }

  ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.init();
  }

  init() {
    this.selected = { startDate: moment().startOf('month'), endDate: moment().endOf('month') };
    localStorage.setItem('range_data_selected', JSON.stringify(this.selected))
    const today = new Date();
    this.setupPresets();
    this.options = {
      presets: this.presets,
      format: 'mediumDate',
      range: { fromDate: today, toDate: today },
      applyLabel: 'Submit',
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: false,
      },
    };
  }

  refreshLogbook() {
    this.eventsSubject.next({ range: this.selected });
  }

  toogleShowAddLogbook() {
    this.showAddLogbook = true;
  }

  hideAddLogbook() {
    this.showAddLogbook = false;
    this.showEditLogbook = false;
  }

  // handler function that receives the updated date range object
  updateRange(range: any) {
    this.startDate = range.startDate ? range.startDate.format('YYYY-MM-DD') : this.startDate;
    this.endDate = range.endDate ? range.endDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : this.endDate;
    this.range = range;
    localStorage.setItem('range_data_selected', JSON.stringify(this.selected))
    this.eventsSubject.next({ range: this.selected });
  }

  // helper function to create initial presets
  setupPresets() {
    const backDate = (numOfDays) => {
      const todayDate = new Date();
      return new Date(todayDate.setDate(todayDate.getDate() - numOfDays));
    };

    const today = new Date();
    const yesterday = backDate(1);
    const minus7 = backDate(7);
    const minus30 = backDate(30);
    const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    this.presets = [
      { presetLabel: 'Yesterday', range: { fromDate: yesterday, toDate: today } },
      { presetLabel: 'Last 7 Days', range: { fromDate: minus7, toDate: today } },
      { presetLabel: 'Last 30 Days', range: { fromDate: minus30, toDate: today } },
      { presetLabel: 'This Month', range: { fromDate: currMonthStart, toDate: currMonthEnd } },
      { presetLabel: 'Last Month', range: { fromDate: lastMonthStart, toDate: lastMonthEnd } },
    ];
  }

  closeModalLogbook() {
    this.hideAddLogbook()
  }

  openModalLogbook() {
    this.logbookType = this.type;
    this.stationId = this.stationId;
    this.toogleShowAddLogbook()
    this.showAddLogbook = this.showAddLogbook
    /* this.dialog.open(AddLogbookComponent, {
      hasScroll: true,
      context: {
        logbookType: this.type,
        stationId: this.stationId,
      },
    }).onClose.subscribe(logbookStored => logbookStored ? this.refreshLogbook() : null); */
  }
}
